import { render, staticRenderFns } from "./AppOrderStore.vue?vue&type=template&id=0628d114&scoped=true"
import script from "./AppOrderStore.vue?vue&type=script&lang=js"
export * from "./AppOrderStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628d114",
  null
  
)

export default component.exports